if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.cartNotification = document.getElementById('cart-notification');
        this.cartNotificationItem = document.getElementById('cart-notification-item');
        this.multi_item_request = false;
        this._submitInProgress = false;
      }

      getLoadingOverlay() {
        return (
          (this.submitButton && this.submitButton.querySelector('.loading-overlay')) ||
          this.querySelector('.loading-overlay')
        );
      }

      setSubmitting(loading) {
        if (!this.submitButton) return;
        const overlay = this.getLoadingOverlay();
        if (loading) {
          this.submitButton.setAttribute('aria-disabled', 'true');
          this.submitButton.classList.add('loading');
          if (overlay) overlay.classList.remove('hidden');
        } else {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (overlay) overlay.classList.add('hidden');
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.form || this._submitInProgress) return;
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const routes = window.routes || {};
        const cartAddJsUrl = (routes.cart_add_url || '/cart/add').replace(/\/$/, '').replace(/\.js$/, '') + '.js';
        const cartAddHtmlUrl = (routes.cart_add_url || '/cart/add').replace(/\.js\/?$/, '').replace(/\/$/, '');

        this.handleErrorMessage();
        this._submitInProgress = true;
        this.setSubmitting(true);

        const upsell_ids_nodes = document.querySelectorAll(
          `[data-form="${this.form.getAttribute('id')}"] .upsell-id`
        );
        const upsell_quantities_nodes = document.querySelectorAll(
          `[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`
        );
        let upsell_items = [];
        if (upsell_ids_nodes.length !== 0) {
          const upsell_ids = Array.from(upsell_ids_nodes).map((input) => parseInt(input.value, 10));
          const upsell_quantities = Array.from(upsell_quantities_nodes).map((input) =>
            parseInt(input.value, 10)
          );
          upsell_items = upsell_ids
            .map((id, index) => ({ id: id, quantity: upsell_quantities[index] }))
            .filter((item) => item.quantity !== 0);
        }

        const formData = new FormData(this.form);
        let json = null;
        let resOk = false;

        const tryAddJson = async (url, body, contentType) => {
          const headers = {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          };
          if (contentType) headers['Content-Type'] = contentType;
          const res = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'same-origin',
            body,
          });
          let parsed = {};
          try {
            parsed = await res.json();
          } catch (e) {
            parsed = {};
          }
          return { res, json: parsed };
        };

        const tryAddHtmlForm = () =>
          new Promise((resolve) => {
            const variantId = formData.get('id');
            const quantity = formData.get('quantity') || '1';
            const params = new URLSearchParams();
            params.set('id', String(variantId));
            params.set('quantity', String(quantity));
            const xhr = new XMLHttpRequest();
            xhr.open('POST', cartAddHtmlUrl, true);
            xhr.withCredentials = true;
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            xhr.setRequestHeader('Accept', 'text/html,application/json,*/*');
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            xhr.onload = () =>
              resolve({ ok: xhr.status >= 200 && xhr.status < 400, json: { variant_id: variantId } });
            xhr.onerror = () => resolve({ ok: false, json: {} });
            xhr.send(params.toString());
          });

        try {
          if (upsell_items.length > 0) {
            this.multi_item_request = true;
            const items = upsell_items;
            const id = parseInt(formData.get('id'), 10);
            const quantity = parseInt(formData.get('quantity'), 10) || 1;
            items.push({ id: id, quantity: quantity });
            let result = await tryAddJson(
              cartAddJsUrl,
              JSON.stringify({ items: items }),
              'application/json'
            );
            if (!result.res.ok && (result.res.status === 403 || result.res.status === 429)) {
              throw new Error(result.json.description || 'Add to cart blocked');
            }
            json = result.json;
            resOk = result.res.ok;
          } else {
            this.multi_item_request = false;
            let result = await tryAddJson(cartAddJsUrl, formData, null);
            if (!result.res.ok && (result.res.status === 403 || result.res.status === 429)) {
              const variantId = parseInt(formData.get('id'), 10);
              const quantity = parseInt(formData.get('quantity'), 10) || 1;
              result = await tryAddJson(
                cartAddJsUrl,
                JSON.stringify({ id: variantId, quantity: quantity }),
                'application/json'
              );
            }
            if (!result.res.ok && (result.res.status === 403 || result.res.status === 429)) {
              const htmlResult = await tryAddHtmlForm();
              if (!htmlResult.ok) {
                throw new Error('Add to cart blocked. Try disabling loyalty/cart apps (Bloy, Smile.io).');
              }
              json = htmlResult.json;
              resOk = true;
            } else {
              json = result.json;
              resOk = result.res.ok;
            }
          }

          if (!resOk) {
            throw new Error(json.description || json.message || 'Add to cart failed');
          }

          let cart = null;
          if (window.FyCardAddToCart && typeof window.FyCardAddToCart.fetchCart === 'function') {
            try {
              cart = await window.FyCardAddToCart.fetchCart();
            } catch (e) {
              /* optional */
            }
          }

          if (cart && window.FyCardAddToCart.updateCartBadges) {
            window.FyCardAddToCart.updateCartBadges(cart.item_count);
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: {
                cart: cart || json,
                skipDrawer: !window.matchMedia('(min-width: 768px)').matches,
              },
            })
          );

          const lineItem = json.items ? json.items[0] : json;
          if (window.FyCardAddToCart && window.FyCardAddToCart.modal && lineItem) {
            const meta = {
              title: lineItem.product_title || lineItem.title || '',
              vendor: lineItem.vendor || '',
              image: lineItem.image || (lineItem.featured_image && lineItem.featured_image.url) || '',
            };
            await window.FyCardAddToCart.modal.show(lineItem, meta, cart);
          } else if (this.cartNotification && this.cartNotificationItem) {
            this.showCartNotification(json);
          }
        } catch (error) {
          this.handleErrorMessage(error.message || error);
          console.error(error);
        } finally {
          this._submitInProgress = false;
          this.setSubmitting(false);
          this.resetQuantityInput();
        }
      }

      showCartNotification(json) {
        const notificationTemplate = document.importNode(this.cartNotification.content, true);
        if (this.multi_item_request) {
          notificationTemplate.querySelector('[data-notification-title]').textContent =
            window.variantStrings.itemsAdded;
          let lastElement = json.items.pop();
          json.items.unshift(lastElement);
          json.items.forEach((item) => {
            const singleItem = this.createNotificationItem(item);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          });
        } else {
          notificationTemplate.querySelector('[data-notification-title]').textContent =
            window.variantStrings.itemAdded;
          const singleItem = this.createNotificationItem(json);
          notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
        }
        if (document.querySelector('.cart-notification')) {
          document.querySelector('.cart-notification').remove();
        }
        document.body.appendChild(notificationTemplate);
        const the_notification = document.querySelector('.cart-notification');
        the_notification.setAttribute('tabindex', '-1');
        the_notification.focus();
        the_notification.querySelector('.notification-close').addEventListener('click', () => {
          the_notification.classList.remove('anim-in');
        });
        setTimeout(() => {
          the_notification.classList.add('anim-in');
        }, 50);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper') ||
          document.querySelector(
            `.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`
          );
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      resetQuantityInput() {
        const hidden_quantity_input = document.querySelector('[type=hidden][name=quantity]');
        if (hidden_quantity_input) {
          hidden_quantity_input.value = 1;
        }
      }

      createNotificationItem(product) {
        const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);
        if (product.image) {
          const filename = product.image.split('/').pop();
          const lastDotIndex = filename.lastIndexOf('.');
          const newFilename = `${filename.substring(0, lastDotIndex)}_120x${filename.substring(lastDotIndex)}`;
          const url = product.image.replace(filename, newFilename);
          notificationItemTemplate.querySelector('.notification-item-image').setAttribute('src', url);
          notificationItemTemplate.querySelector('.notification-item-image').classList.remove('hide');
        }
        notificationItemTemplate.querySelector('.notification-item-title').textContent =
          product.product_title || product.title || '';
        if (product.options_with_values && product.options_with_values.forEach) {
          product.options_with_values.forEach((item) => {
            const row = document.createElement('dl');
            const nameCell = document.createElement('dt');
            const valueCell = document.createElement('dd');
            nameCell.textContent = item.name + ': ';
            valueCell.textContent = item.value;
            row.appendChild(nameCell);
            row.appendChild(valueCell);
            notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
          });
        }
        const propertyKeyValues = Object.entries(product.properties || {});
        if (propertyKeyValues.length > 0) {
          const properties = document.createElement('dl');
          propertyKeyValues.forEach(([key, value]) => {
            if (key.startsWith('_')) return;
            const row = document.createElement('dl');
            const nameCell = document.createElement('dt');
            const valueCell = document.createElement('dd');
            nameCell.textContent = key + ': ';
            valueCell.textContent = value;
            row.appendChild(nameCell);
            row.appendChild(valueCell);
            properties.appendChild(row);
          });
          notificationItemTemplate.querySelector('.notification-item-details').appendChild(properties);
        }
        return notificationItemTemplate;
      }
    }
  );
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();
    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent('submit', { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value, 10);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${formId}]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }
  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define('add-multiplier', AddMultiplier);
